export default __webpack_public_path__ + "static/media/hht1_ep09_book_wp_02.110e8c82.jpg";